import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, TransitionGroup as _TransitionGroup, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e4af9f34")

_pushScopeId("data-v-e4af9f34")
const _hoisted_1 = { class: "title center mb2" }
const _hoisted_2 = { class: "player-info flex items-center" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "player-name" }
const _hoisted_5 = {
  key: 0,
  class: "player-nick"
}
const _hoisted_6 = {
  key: 0,
  class: "player-job"
}
const _hoisted_7 = {
  key: 1,
  class: "player-points--new"
}
const _hoisted_8 = {
  key: 2,
  class: "flex items-center justify-center player-remove"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Chip = _resolveComponent("Chip")!
  const _component_BaseTooltipWrapper = _resolveComponent("BaseTooltipWrapper")!

  return (_openBlock(), _createBlock("div", {
    class: ["current-results", {
      'current-results--quite-lots-of-players': $props.game.players.length > 5 && $props.game.players.length <= 8,
      'current-results--lots-of-players': $props.game.players.length > 8
    }]
  }, [
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t(`funIceBreaker.currentResults`)), 1),
    _createVNode(_TransitionGroup, {
      name: "flip-list",
      tag: "div"
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.sortedPlayers, (player) => {
          return (_openBlock(), _createBlock("div", {
            key: player.id,
            class: "player flex items-center justify-between"
          }, [
            ($setup.showIndicator(player.id))
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  class: "player-indicator",
                  src: require(`@/assets/images/ready.svg`),
                  alt: "Ready indicator"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_2, [
              (player.avatar)
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    alt: player.avatar.name,
                    src: require(`@/assets/avatars/${player.avatar.pack}/${player.avatar.name}.svg`),
                    class: "avatar"
                  }, null, 8, ["alt", "src"]))
                : _createCommentVNode("", true),
              _createVNode("div", null, [
                _createVNode("div", _hoisted_3, [
                  _createVNode("div", _hoisted_4, [
                    _createTextVNode(_toDisplayString(player.name) + " ", 1),
                    (player.nickname)
                      ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(player.nickname), 1))
                      : _createCommentVNode("", true),
                    (player.admin)
                      ? (_openBlock(), _createBlock(_component_Chip, {
                          key: 1,
                          class: "small ml1"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(player.admin ? `${_ctx.$t('players.admin')}` : ''), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    (player.id === $setup.currentPlayer.id)
                      ? (_openBlock(), _createBlock(_component_Chip, {
                          key: 2,
                          class: "small primary ml1"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(player.id === $setup.currentPlayer.id ? `${_ctx.$t('players.you')}` : ''), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (player.job)
                  ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(player.job), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", {
              class: ["player-points", {
            added: $setup.added && player.pointsInPreviousRound > 0
          }]
            }, _toDisplayString(player.points) + " " + _toDisplayString(_ctx.$t(`funIceBreaker.points`)), 3),
            (
            ($props.game?.phase === $data.FUN_ICE_BREAKER_PHASES.QUESTION.value ||
              $props.game?.phase === $data.FUN_ICE_BREAKER_PHASES.STORY.value) &&
            player.points > 0
          )
              ? (_openBlock(), _createBlock("div", _hoisted_7, " +" + _toDisplayString(player.pointsInPreviousRound), 1))
              : _createCommentVNode("", true),
            ($setup.checkIfPlayerCanBeDeleted(player.id))
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode(_component_BaseTooltipWrapper, {
                    tooltip: _ctx.$t('common.removePlayer')
                  }, {
                    default: _withId(() => [
                      _createVNode("i", {
                        class: "pi pi-user-minus",
                        onClick: ($event: any) => ($setup.handleDeletePlayer(player.id))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["tooltip"])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _: 1
    })
  ], 2))
})